// src/common/hooks/useScreenTracking.ts
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import useMetrics from "./useMetrics";
import { GoalType } from "../types/enums";

export const useScreenTracking = () => {
  const { trackGoal } = useMetrics();

  const isOnline = useSelector((state: RootState) => state.network.isOnline);
  const saleItemList = useSelector((state: RootState) => state.saleItemList);
  const storeList = useSelector(
    (state: RootState) => state.storeList.data.data,
  );
  const currentCluster = useSelector(
    (state: RootState) => state.currentCluster.cluster,
  );

  const saleItemsCount = saleItemList.data.ids.length;

  const activeStores = storeList.filter(
    (s) => s.isActive && !s.temporarilyDisabled,
  );

  const getBaseContext = () => ({
    isOnline,
    saleItemsCount,
    activeStoreCount: activeStores.length,
    clusterActive: currentCluster?.isActive ?? false,
  });

  const trackTechnicalWork = () => {
    trackGoal(GoalType.TECHNICAL_WORK, "technical_work_screen", {
      ...getBaseContext(),
    });
  };

  const trackNoNetwork = () => {
    trackGoal(GoalType.NO_NETWORK, "no_network_screen", {
      ...getBaseContext(),
    });
  };

  const trackEmptyCatalog = () => {
    trackGoal(GoalType.EMPTY_CATALOG, "empty_catalog_screen", {
      ...getBaseContext(),
    });
  };

  return {
    trackTechnicalWork,
    trackNoNetwork,
    trackEmptyCatalog,
  };
};
